import React from "react";
import Routes from "./Routes";
import PromoPopup from "./components/promo/PromoPopup";

function App() {
  return (
    <>
      <PromoPopup />
      <Routes />
    </>
  );
}

export default App;
